/**
 * 결제 내역 페이지 라우트
 * FSD: pages/payment-history
 */

import { RouteObject } from 'react-router-dom';
import PaymentHistoryPage from './ui/PaymentHistoryPage';

export const paymentHistoryRoute: RouteObject = {
  path: '/payment/history',
  element: <PaymentHistoryPage />,
};
